import { Link } from "react-router";
import { ICONS } from "../assets/icons";
import { CONSTANTS } from "../constants";

const IzunefeshLogo = ({ notClickable }: { notClickable?: boolean }) => {
  return notClickable ? (
    <div className="items-center justify-center flex">
      <img src={ICONS.LOGO} alt="logo" />
    </div>
  ) : (
    <Link
      to={CONSTANTS.ROUTES.home}
      className="cursor-pointer items-center justify-center flex">
      <img src={ICONS.LOGO} alt="logo" />
    </Link>
  );
};

export default IzunefeshLogo;
